import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import OnboardingAPI from 'dashboard/api/onboarding';

// Fixed sidebar entry that resumes the onboarding wizard while the account status is
// in_progress/skipped (ADR-006) — admin-only, and hidden once onboarding is completed
// or never started, or when the onboarding_wizard feature flag is off.
export function useOnboardingResumeMenuItem() {
  const { t } = useI18n();
  const { accountScopedRoute, isCloudFeatureEnabled } = useAccount();
  const { isAdmin } = useAdmin();

  const isOnboardingWizardEnabled = computed(() =>
    isCloudFeatureEnabled(FEATURE_FLAGS.ONBOARDING_WIZARD)
  );
  const onboardingStatus = ref(null);

  onMounted(() => {
    if (!isOnboardingWizardEnabled.value || !isAdmin.value) return;

    OnboardingAPI.get()
      .then(({ data }) => {
        onboardingStatus.value = data.status;
      })
      .catch(() => {
        // Resuming onboarding is a convenience shortcut — failing silently here just
        // keeps the menu item hidden, it doesn't block the rest of the sidebar.
      });
  });

  const shouldShow = computed(
    () =>
      isOnboardingWizardEnabled.value &&
      isAdmin.value &&
      ['in_progress', 'skipped'].includes(onboardingStatus.value)
  );

  const menuItem = computed(
    () =>
      shouldShow.value && {
        title: t('ONBOARDING.SIDEBAR_CARD.TITLE'),
        subtitle: t('ONBOARDING.SIDEBAR_CARD.SUBTITLE'),
        to: accountScopedRoute('account_onboarding'),
      }
  );

  return { menuItem };
}
